/**
 * A category snapshot from GET /scene/list, holding the id and the display label
 * that the server captured at save time. The client declares the shape itself,
 * because client and server share the wire format alone.
 */
export interface SceneCategory {
  id: string;
  label: string;
}

/** The scene's editorial classification, where a field is null when the save
 * omitted it, and the whole object is null on an older scene. */
export interface SceneContext {
  channel: SceneCategory | null;
  product: SceneCategory | null;
  type: SceneCategory | null;
}

/**
 * Join the stored channel, product, and type labels into "Channel · Product ·
 * Type" for a work-history row. The stored labels need no catalog lookup, so a
 * renamed or deleted product leaves the row legible. An empty or all-null
 * context yields null, and the caller falls back to the scene id.
 */
export function formatSceneContext(context: SceneContext | null | undefined): string | null {
  if (!context) return null;
  const parts = [context.channel?.label, context.product?.label, context.type?.label].filter(
    Boolean
  );
  return parts.length ? parts.join(" · ") : null;
}
